const version = "2.3.14";

export { version };
//# sourceMappingURL=version.mjs.map
